import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC, useState, useEffect } from "react";

import "react-multi-carousel/lib/styles.css";
import Info from "../../assets/images/Info.png";
import Notification from "../../assets/images/Notification.png";
import userDefault from "../../assets/images/userDefault.png";
import { useAppSelector } from "../../core/feature/hooks";
import Company from "../../core/models/company";
import User from "../../core/models/user";
import closepayLogo from "../../assets/images/closepayLogo.svg";

import info from "../../assets/images/info.svg";
import notification from "../../assets/images/notification.svg";
import closepay_white from "../../assets/images/icon_closepay/closepay-white.svg";
import {
  faSearch,
  faHome,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Token from "../../core/models/token";
import { find } from "lodash";
import home from "../../assets/images/icon_nav/home.svg";
import history from "../../assets/images/icon_nav/history.svg";
import profile from "../../assets/images/icon_nav/profile.svg";
import message from "../../assets/images/icon_nav/message.svg";
import homeActive from "../../assets/images/icon_nav/home-active.svg";
import historyActive from "../../assets/images/icon_nav/history-active.svg";
import profileActive from "../../assets/images/icon_nav/profile-active.svg";
import messageActive from "../../assets/images/icon_nav/message-active.svg";
import CustomApp from "../../core/models/customApp";
import { useTranslation } from "react-i18next";
import { isDarkColor } from "../../config/DarkColorChecker";
interface BottomNavProps {
  tab?: string;
}

const BottomNav: FC<BottomNavProps> = (props): JSX.Element => {
  const company: Company = useAppSelector((state) => state.company.company);
  const user: User = useAppSelector((state) => state.user.user);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const { t } = useTranslation();
  const homeTitle = t("NAVBAR.home");
  const infoTitle = t("NAVBAR.info");
  const inboxTitle = t("NAVBAR.inbox");
  const profileTitle = t("NAVBAR.profile");
  const [listTabs, setlistTabs] = useState<any[]>([]);
  const tabs = [
    {
      route: "/home",
      icon: home,
      iconActive: homeActive,
      label: homeTitle,
      active: false,
    },
    {
      route: "/info",
      icon: history,
      iconActive: historyActive,
      label: infoTitle,
      active: false,
    },
    {
      route: "/message",
      icon: message,
      iconActive: messageActive,
      label: inboxTitle,
      active: false,
    },
    {
      route: "/profile",
      icon: profile,
      iconActive: profileActive,
      label: profileTitle,
      active: false,
    },
  ];
  const loadData = async () => {
    const item = tabs.find((item) => item.label === props.tab);
    if (item != null) {
      item.active = true;
    }

    setlistTabs(tabs);
  };

  useEffect(() => {
    console.log("props", props);

    loadData();
  }, []);
  const activeNav =
    "grow flex flex-row justify-center gap-2 px-3 py-2.5 m-0 rounded-full";
  return (
    <>
      <section className="fixed z-50 bottom-0 w-full bg-white px-2 py-2">
        <div className="relative">
          {/* <span
            className={`absolute bg-psp-hover w-28 rounded-full h-12 z-1 top-2 ${
              props.tab == "Info"
                ? "transition-transform sca"
                : "translate-x-0"
            }`}
          ></span> */}

          <ul className="m-0 p-0 flex flex-row gap-1 justify-center items-center z-50 h-16">
            {listTabs.map((item) =>
              item.active == true ? (
                <Link to={item.route} className="no-underline">
                  <li className={activeNav}>
                    <div
                      style={{ backgroundColor: customApp?.app_accent_color }}
                      className={`relative m-0 flex flex-row items-center w-fit z-50 overflow-hidden anima`}
                    >
                      <img
                        src={item.iconActive}
                        width={30}
                        className={`anima-icon ${isDarkColor(customApp?.app_accent_color)?"":"invert"}`}
                      />
                      <span className={`anima-text ${isDarkColor(customApp?.app_accent_color)?"text-white":"text-black"}`}>
                        {item.label}
                      </span>
                    </div>
                  </li>
                </Link>
              ) : (
                <Link to={item.route} className="no-underline z-50">
                  <li className="flex-0 ">
                    <div className="py-2 px-3">
                      <img src={item.icon} width={30} />
                    </div>
                  </li>
                </Link>
              )
            )}
          </ul>
        </div>
      </section>
    </>
  );
};

export default BottomNav;
